import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import Router from "./Router";
import ErrorBoundary from "./components/ErrorBoundary";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  enabled: !!process.env.REACT_APP_SENTRY_DSN,
});

// Initialise PostHog (production only) — wrapped in try/catch so adblockers
// that block posthog scripts never throw uncaught errors or block rendering.
if (process.env.NODE_ENV === "production" && process.env.REACT_APP_POSTHOG_KEY) {
  try {
    posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
      api_host: process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com",
      capture_pageview: false,          // we fire manually via usePageViewTracking
      autocapture: true,
      respect_dnt: true,
      person_profiles: "identified_only",
      enable_recording_console_log: false,
      session_recording: {
        maskAllInputs: true,
        maskInputOptions: { password: true, email: true, number: true },
      },
    });
  } catch { /* non-fatal — analytics blocked by adblocker */ }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router />
    </ErrorBoundary>
  </React.StrictMode>
);
